import React from 'react';
import { Link } from 'react-router-dom';

const FeaturedCategoryTiles = () => {
    return (
        <div className={'feat-cat-tiles row'}>
            <div className="col-sm-12 col-md-6">
                <div className="feat-cat-tile block">
                    <Link
                        className="block__heading"
                        to={'/discover/marketing'}
                    >
                        <h5 className="block__title">Marketing</h5>
                    </Link>

                    <Link
                        className={'feat-cat-tile__img'}    
                        to={'/discover/marketing'}
                    >
                        <img src="/img/marketing.jpg" alt=""/>
                    </Link>
                </div>
            </div>

            <div className="col-sm-12 col-md-6">
                <div className="feat-cat-tile block">
                    <Link
                        className="block__heading"
                        to={'/discover/finance'}
                    >
                        <h5 className="block__title">Fundraising</h5>
                    </Link>

                    <Link
                        className={'feat-cat-tile__img'}
                        to={'/discover/finance'}
                    >
                        <img src="/img/fundraising.jpg" alt=""/>
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default FeaturedCategoryTiles;



// WEBPACK FOOTER //
// ./src/js/components/FeaturedCategoryTiles.js